<template>
  <button 
    :type="type"
    class="w-[120px] bg-brand-600 hover:bg-brand-700 text-white 
        font-semibold py-2 px-4 rounded-lg shadow-md transition 
        duration-300 ease-in-out transform hover:scale-105 
        focus:outline-none focus:ring-2 focus:ring-brand-600 focus:ring-opacity-50"
  >
    {{ text }}
  </button>
</template>

<script lang="ts">
import type { PropType } from 'vue';

type ButtonType = 'button' | 'submit' | 'reset';

export default {
  name: 'BaseButton',
  props: {
    text: {
      type: String,
      required: true
    },
    type: {
      type: String as PropType<ButtonType>,
      default: 'button'
    }
  }
}
</script>
